var _path, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 916,
    height: 301,
    viewBox: "0 0 916 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.7812 160.48H104.83C104.254 139.514 85.7173 124.301 59.1264 124.301C32.8551 124.301 12.7202 139.322 12.7202 161.886C12.7202 180.104 25.7599 190.778 46.7898 196.467L62.2585 200.686C76.2571 204.393 87.0597 208.996 87.0597 220.629C87.0597 233.413 74.8509 241.851 58.0398 241.851C42.8267 241.851 30.1705 235.075 29.0199 220.821H9.20455C10.483 244.536 28.8281 259.173 58.1676 259.173C88.9134 259.173 106.619 243.001 106.619 220.821C106.619 197.234 85.5895 188.094 68.9702 184.003L56.1861 180.679C45.9588 178.058 32.3438 173.264 32.4077 160.736C32.4077 149.614 42.571 141.368 58.679 141.368C73.7003 141.368 84.375 148.399 85.7812 160.48ZM170.044 258.982C197.722 258.982 215.811 238.719 215.811 208.357C215.811 177.803 197.722 157.54 170.044 157.54C142.367 157.54 124.277 177.803 124.277 208.357C124.277 238.719 142.367 258.982 170.044 258.982ZM170.108 242.938C152.019 242.938 143.581 227.149 143.581 208.293C143.581 189.5 152.019 173.52 170.108 173.52C188.07 173.52 196.507 189.5 196.507 208.293C196.507 227.149 188.07 242.938 170.108 242.938ZM256.257 198.705C256.257 183.044 265.845 174.095 279.141 174.095C292.116 174.095 299.979 182.597 299.979 196.851V257H319.091V194.55C319.091 170.26 305.732 157.54 285.661 157.54C270.895 157.54 261.243 164.379 256.705 174.798H255.49V158.818H237.145V257H256.257V198.705ZM386.08 258.982C413.757 258.982 431.847 238.719 431.847 208.357C431.847 177.803 413.757 157.54 386.08 157.54C358.402 157.54 340.312 177.803 340.312 208.357C340.312 238.719 358.402 258.982 386.08 258.982ZM386.143 242.938C368.054 242.938 359.616 227.149 359.616 208.293C359.616 189.5 368.054 173.52 386.143 173.52C404.105 173.52 412.543 189.5 412.543 208.293C412.543 227.149 404.105 242.938 386.143 242.938ZM454.714 257H474.466V199.919H530.076V182.98H474.466V143.094H535.893V126.091H454.714V257ZM614.691 216.283C614.755 232.966 602.354 240.892 591.616 240.892C579.79 240.892 571.609 232.327 571.609 218.967V158.818H552.496V221.268C552.496 245.622 565.856 258.278 584.712 258.278C599.478 258.278 609.513 250.48 614.052 239.997H615.075V257H633.867V158.818H614.691V216.283ZM678.659 198.705C678.659 183.044 688.248 174.095 701.543 174.095C714.519 174.095 722.381 182.597 722.381 196.851V257H741.493V194.55C741.493 170.26 728.134 157.54 708.063 157.54C693.297 157.54 683.645 164.379 679.107 174.798H677.892V158.818H659.547V257H678.659V198.705ZM791.223 126.091H770.194L771.855 219.351H789.561L791.223 126.091ZM780.676 258.214C787.644 258.214 793.461 252.526 793.461 245.43C793.461 238.463 787.644 232.71 780.676 232.71C773.645 232.71 767.892 238.463 767.892 245.43C767.892 252.526 773.645 258.214 780.676 258.214Z",
    fill: "#CFCFCF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.986,
    y: 13.8731,
    width: 270.55,
    height: 118,
    rx: 12,
    transform: "rotate(20.9094 644.986 13.8731)",
    stroke: "#E4E4E4",
    strokeWidth: 6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.546 111.799L685.761 126.399L688.438 119.393L658.121 107.81L680.362 49.5961L672.464 46.5788L647.546 111.799ZM696.971 130.682L704.487 133.553L723.175 84.638L715.659 81.7667L696.971 130.682ZM722.595 75.0741C725.525 76.1935 728.822 74.8252 729.892 72.0228C730.963 69.2203 729.419 66.0028 726.489 64.8834C723.559 63.7641 720.263 65.1323 719.192 67.9348C718.121 70.7372 719.666 73.9548 722.595 75.0741ZM776.939 105.178L768.786 102.064L740.391 135.884L739.882 135.69L741.271 91.5517L733.119 88.4371L732.519 144.263L740.162 147.183L776.939 105.178ZM786.538 166.069C796.474 169.865 805.633 167.671 810.749 161.159L804.267 156.347C800.409 160.712 795.009 161.568 789.118 159.318C780.297 155.947 776.392 147.923 780.044 137.312L815.553 150.878L816.769 147.693C823.729 129.478 815.286 119.099 805.095 115.206C791.847 110.144 779.067 117.232 773.324 132.263C767.582 147.294 772.399 160.667 786.538 166.069ZM782.526 130.816C785.944 123.399 793.917 118.672 802.516 121.957C810.668 125.072 813.555 133.181 810.392 141.461L782.526 130.816Z",
    fill: "#E4E4E4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 861.953,
    cy: 121.387,
    rx: 8.5,
    ry: 8,
    transform: "rotate(20.9094 861.953 121.387)",
    fill: "#E4E4E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 579,
    y: 0,
    width: 342.592,
    height: 254.532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.154167 0 0 0 0 0.154167 0 0 0 0 0.154167 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 640.546,
    y: 43.5786,
    width: 185.769,
    height: 135.351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 843.158,
    y: 106.88,
    width: 37.5907,
    height: 37.0135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBw);
export default __webpack_public_path__ + "static/media/logoBw.e9676e3ef8793f4d0c751e258b97427e.svg";
export { ForwardRef as ReactComponent };